<template>
  <app-mask-field v-bind="$attrs" hide-details="auto" v-on="$listeners" dense label="CEP" @input="handleInput($event)"
    :loading="loading" mask="#####-###" autocomplete="off" />
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    loading: false,
    lastSearchedCep: null,
  }),

  methods: {
    handleInput(cep) {
      if (cep.length != 9) {
        this.lastSearchedCep = null;
        return;
      }

      if (this.loading || cep === this.lastSearchedCep) {
        return;
      }

      this.lastSearchedCep = cep;
      this.searchCep(cep);
    },

    async searchCep(cep) {
      this.loading = true;

      try {
        const address = await this.fetchViaCep(cep);
        this.handleCepInput(address);
      } catch (e) {
        try {
          const address = await this.fetchOpenCep(cep);
          this.handleCepInput(address);
        } catch (fallbackError) {
          // CEP não encontrado em nenhum provedor
        }
      }

      this.loading = false;
    },

    async fetchViaCep(cep) {
      const { data } = await axios.get(
        `https://viacep.com.br/ws/${cep}/json/`
      );

      if (data.erro) {
        throw new Error("CEP não encontrado no ViaCEP");
      }

      return data;
    },

    async fetchOpenCep(cep) {
      const onlyDigits = cep.replace(/\D/g, "");

      const { data } = await axios.get(
        `https://opencep.com/v1/${onlyDigits}`
      );

      return data;
    },
    handleCepInput(address) {
      this.$emit("address", {
        city: address.localidade,
        address: address.logradouro,
        district: address.bairro,
        state: address.uf,

        city_code: address.ibge,
        postal_code: address.cep,
      });
    },
  },
};
</script>